export default __webpack_public_path__ + "static/media/man-headphones-resting.6018e31b.svg";